import { token } from '@atlaskit/tokens';

import type { BaseDecoration, Decoration } from './types/decoration';

/**
 * Builds a `Decoration` that visually highlights a matched search term
 * range within a line of code, using `<mark>` markup and yellow-accent
 * color tokens.
 *
 * Consumers reach for this helper when they want to visually highlight
 * search term matches without diverging from the look adopted by other
 * consumers of this package — for example, to highlight matches
 * produced by their own client-side matcher, or to compose highlights
 * alongside other decoration kinds.
 */
export const searchHighlightDecoration = ({
	lineNumber,
	startChar,
	endChar,
}: BaseDecoration): Decoration => ({
	lineNumber,
	startChar,
	endChar,
	tagName: 'mark',
	style: {
		backgroundColor: token('color.background.accent.yellow.subtler'),
		color: token('color.text.accent.yellow.bolder'),
	},
});
